export async function getData(route = '', data = {}) {
    try {
        const params = Object.keys(data).map(key => {
            return `${key}=${encodeURIComponent(data[key])}`
        })
        const url = `/.netlify/functions/${route}?${params.join('&')}`;
        const response = await fetch(url, {
        method: 'GET', 
        headers: {
            'Content-Type': 'application/json'
        },
        redirect: 'follow', 
        });
        if (response.ok) {
            return response.json();
        }
    } catch (err) {
        // do nothing on error 
    }
    return null;
  }